import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/network";

export const networkingApi = {
  getConnections: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/connections?${searchParams.toString()}`);
  },

  getFollowers: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/followers?${searchParams.toString()}`);
  },

  getFollowing: (params?: PaginatedParams) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}/following?${searchParams.toString()}`);
  },

  getSuggestions: () => apiGet<{ users: Record<string, unknown>[] }>(`${BASE}/suggestions`),

  connect: (userId: string) => apiPost<{ message: string }>(`${BASE}/connect`, { userId }),

  disconnect: (userId: string) => apiPost<{ message: string }>(`${BASE}/disconnect`, { userId }),

  follow: (userId: string) => apiPost<{ message: string }>(`${BASE}/follow`, { userId }),

  unfollow: (userId: string) => apiPost<{ message: string }>(`${BASE}/unfollow`, { userId }),

  block: (userId: string) => apiPost<{ message: string }>(`${BASE}/block`, { userId }),

  unblock: (userId: string) => apiPost<{ message: string }>(`${BASE}/unblock`, { userId }),
};
